import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProfileSettings } from 'src/app/models/server/profile-settings';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class ProfileSettingsService extends ServiceBase {
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Met à jour le paramétrage du profil
     * @param data : Instance du paramétrage.
     * @returns : L'instance du paramétrage modifié.
     */
    public update(data: ProfileSettings): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http.put(this.baseUrl + `/api/organizations/${this.organizationId}/profileSettings/`, ProfileSettings.toJSON(data), httpOptions).pipe(
            map((x) => {
                return true;
            })
        );
    }
}
